import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";

export default function FaqSection() {
  return (
    <section className="container-x py-14 md:py-20" aria-labelledby="faq-heading">
      <div className="grid gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            常见问题
          </span>
          <h2 id="faq-heading" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            你可能想知道的
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于分类方式、更新节奏、作品状态等常见疑问，我们都为你做了整理。点击问题即可展开查看答案。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看全部问答
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="lg:col-span-2">
          <FaqAccordion />
        </div>
      </div>
    </section>
  );
}